import React, { FC, useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import CheckboxField from 'buyside/components/presentation/Fields/checkboxField';
import Modal from 'buyside/components/presentation/Modal/modal';
import UsernameForm from 'buyside/components/presentation/UsernameForm/usernameForm';

import { IdeaFormInput } from 'buyside/util/researchSubmission';

import styles from '../disclaimersStyles.scss';

const AnonymousField: FC<{ currentUserId: string }> = ({ currentUserId }) => {
  const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);

  const {
    formState: { isSubmitting },
    setValue
  } = useFormContext<IdeaFormInput>();

  const renderOpenUsernameModalButton = useCallback(
    () => (
      <Button
        className={styles.anonymousUsernameButton}
        disabled={isSubmitting}
        onClick={() => setIsUsernameModalOpen(true)}
        text="Update Your Anonymous Username (optional)"
        type={BUTTON_TYPES.LINK}
      />
    ),
    [isSubmitting]
  );

  const generateHelperElement = useCallback(
    () => (
      <Modal
        isOpen={isUsernameModalOpen}
        onClose={() => setIsUsernameModalOpen(false)}
        renderOpenModalButton={renderOpenUsernameModalButton}
        title="Register Username"
      >
        <UsernameForm userId={currentUserId} />
      </Modal>
    ),
    [currentUserId, isUsernameModalOpen, renderOpenUsernameModalButton]
  );

  const onChangeCallback = useCallback(
    (anonymous: boolean) => {
      if (anonymous) setValue('fundProfileDisplay', false);
    },
    [setValue]
  );

  return (
    <CheckboxField
      generateHelperElement={generateHelperElement}
      label="POST THIS IDEA ANONYMOUSLY"
      name="anonymous"
      onChangeCallback={onChangeCallback}
      size="small"
    />
  );
};

export default AnonymousField;
